const Home = () => {
    const scrollDown = document.getElementById('scrollDown');
    const imageMap = document.getElementById('imageMap');

    if (scrollDown && imageMap) {
        scrollDown.addEventListener('click', () => {
            imageMap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
};

export default Home;
